<template>
  <el-drawer
    :title="title"
    :visible.sync="popoverVisible"
    size="600px"
    @open="refleshSelectAndDisableData">
    <div style="background: #fff;border: 1px solid #DCDFE6;border-radius: 15px;">
      <el-row>
        <el-col :span="12" style="border-right: 1px solid #DCDFE6;border-bottom: 1px solid #DCDFE6;height: 80vh;padding: 20px;">
          <el-input
            size="small"
            placeholder="输入关键字进行过滤"
            v-model="filterText"
            style="padding-bottom: 20px;">
          </el-input>
          <el-tree
            class="filter-tree"
            :data="copyData"
            node-key="value"
            :show-checkbox="true"
            :props="defaultProps"
            @check-change="handleTreeChange"
            :filter-node-method="filterNode"
            ref="tree">
          </el-tree>
        </el-col>
        <el-col :span="12" style="height: 80vh;border-bottom: 1px solid #DCDFE6;color: black;">
          <div>
            <div style="font-size: 16px;border-bottom: 1px solid #DCDFE6;padding: 20px;">
              {{ isApproval ? "审批人/处理人(最多10人)" : "抄送人(最多5人)" }}
            </div>
            <div class="g-column" style="padding: 10px 20px 20px 20px;">
              <el-row v-for="(item,index) in currentPersonData" :key="item.value" style="padding-bottom: 10px;height: 40px;line-height: 40px;">
                <el-col :span="12" style="text-align: left;">
                  {{ item.title }}
                </el-col>
                <el-col :span="12" style="text-align: right;">
                  <el-button type="text" @click="del(index)">移除</el-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>
      <div style="padding: 20px;text-align: right;">
        <el-button class="g-plain-confirm-btn" size="mini" plain @click="handleAddApproval">创建</el-button>
        <el-button size="mini" plain @click="handleClose">取消</el-button>
      </div>
    </div>

  </el-drawer>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import _ from 'lodash';
export default {
  name: 'drawTree',

  components:{},

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },

  data () {
    return {
			copyData: [],
      popoverVisible: false,
      currentPersonData: {},
      filterText: ""
    }
  },

  props: {
		index: {
			type: Number,
			default: 0
		},
		ii: {
			type: Number,
			default: 0
		},
    isApproval: {
      require: true,
      type: Boolean
    },
    data: {
      require: true,
      type: Array,
      default: () => []
    },
    defaultProps: {
      require: true,
      type: Object,
    },
    title: {
      type: String,
      required: true
    }
	},

  methods: {
    // 删除
    del(index) {
      this.currentPersonData.splice(index,1)
      let arrValue = []
      for (let a in this.currentPersonData) {
        arrValue.push(this.currentPersonData[a].value)
      }
      this.$refs.tree.setCheckedKeys(arrValue)
    },
    handleClose() {
      this.popoverVisible = false;
    },
    handleAddApproval() {
      if(this.currentPersonData.title || this.getCopyTreeIdArr().length) {
        if (this.title == '抄送人' || this.title == '审批人' || this.title == '处理人') {
          this.$emit('up-approval', {
  					isApproval: this.isApproval ? true : false,
  					id: this.getCopyTreeIdArr(),
            cb: () => {
              this.popoverVisible = false;
  						this.currentPersonData = "";
            }
          });
        } else {
          this.$emit('add-approval', {
  					isApproval: this.isApproval ? true : false,
  					id: this.getCopyTreeIdArr(),
            cb: () => {
              this.popoverVisible = false;
  						this.currentPersonData = "";
            }
          });
        }

      }else {
        this.$message.warning('请选择节点');
      }
    },
    getCopyTreeIdArr() {
      let arr = this.$refs.tree.getCheckedKeys().filter((item) => {
        return item != undefined;
      })
      return arr;
    },
    // 人数限制
    handleTreeChange(data, isSelect, node) {
			let arr = this.getCopyTreeIdArr();
      if(!this.isApproval && arr.length > 5) {
        this.$message.warning('抄送人不超过5人');
        this.$refs.tree.setCheckedKeys(arr.slice(0, 5), true);
			}
			if(this.isApproval && arr.length > 10) {
        this.$message.warning('审批/处理人不超过10人');
        this.$refs.tree.setCheckedKeys(arr.slice(0, 10), true);
      }
      const res = this.$refs.tree.getCheckedNodes().filter((item) => {
        return item.type != 'dept';
      })
      this.currentPersonData = res;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
		},
		getNeedDisableKeys(index, ii) {
			const res = [];
			const singleList = this.getApprovalTempletList[index];
			singleList.forEach((item, i) => {
				if(item.approvaluseid && (i !== ii || ii === singleList.length)) {
					const keys = item.approvaluseid.split(',');
					res.push(...keys)
				}
			})
			return res;
		},
		setDiabledKeys(index, ii) {
			const needDisableKeys = this.getNeedDisableKeys(index, ii);
			function loop(data) {
				data.forEach(item => {
					if(item.children) {
						loop(item.children)
					}else {
						if(needDisableKeys.includes(String(item.value))) {
							item.disabled = true;
						}
					}
				})
			}

			const data = _.cloneDeep(this.getActivityPerson);
			loop(data);
			this.copyData = data;
		},
		setSelectKeys(index, ii) {
			const singleList = this.getApprovalTempletList[index];
			if(ii === singleList.length) {
				return;
			}else {
				const item = singleList[ii];
				if(item && item.approvaluseid) {
					const selectKeys = item.approvaluseid.split(',');
          this.$nextTick(() => {
              this.$refs.tree.setCheckedKeys(selectKeys, true);
              this.setCurrentPersonData(selectKeys);
          });
				}
			}
		},
		setCurrentPersonData(selectKeys) {
			const res = [];
			function loop(data) {
				data.forEach(item => {
					if(item.children) {
						loop(item.children)
					}else {
						if(selectKeys.includes(String(item.value))) {
							res.push(item)
						}
					}
				})
			}
			loop(this.copyData);
			this.currentPersonData = res;
		},
		refleshSelectAndDisableData() {
      let vv = this.getApprovalTempletList[this.index].length
      // this.ii = this.getApprovalTempletList[this.index].length
			if(this.isApproval) {
				// this.setDiabledKeys(this.index, this.ii);
				// this.setSelectKeys(this.index, this.ii);
        this.setDiabledKeys(this.index, vv);
				this.setSelectKeys(this.index, vv);
			}else {
				this.copyData = this.getActivityPerson;
			}
		}
  },

  computed: {
		...mapGetters([
			'getActivityPerson',
			'getApprovalTempletList'
		]),
	},

  created() {},

  // mounted() {
  //   this.refleshSelectAndDisableData();
	// },
}
</script>


<style lang='scss'>
.g-column {
  display: flex;
  flex-direction: column;
}

.approval-process-add-box {
  position: relative;
  box-sizing: border-box;
  padding: 10px;
  text-align: center;
  width: 100%;
  min-height: 250px;
  border: 1px solid rgb(199, 199, 199);

  .approval-process-add-box-footer {
    position: absolute;
    bottom: 5px;
    right: 5px;
  }
}

.g-plain-confirm-btn {
  border-color: #1C9EFB !important;
  color: #1C9EFB;
}
</style>
